export const VERSION = process.env.REACT_APP_VERSION || ''
export const AVOD_REGISTRATION_FEATURE_ENABLED =
  process.env.REACT_APP_AVOD_REGISTRATION_FEATURE_ENABLED === 'true'
export const DEBUG = process.env.REACT_APP_DEBUG || false
export const VERSION_PRELEASE = process.env.REACT_APP_VERSION_PRERELEASE || ''
export const REACT_APP_SSR = process.env.REACT_APP_SSR === 'true'
export const REACT_APP_BOOTPAY_APPLICATION_ID =
  process.env.REACT_APP_BOOTPAY_APPLICATION_ID || ''
